import { MpBattlePack } from './IBattlePack.js';
export var ScourgeType;
(function (ScourgeType) {
    ScourgeType["None"] = "None";
    ScourgeType["SoG"] = "Scourge of Ghyran";
    ScourgeType["SoA"] = "Scourge of Aqshy";
})(ScourgeType || (ScourgeType = {}));
// The battlepack each scourge type is native to. Scourge content is allowed by
// default only in its native pack; elsewhere it requires the matching home rule
// (see isScourgeAllowed in the validators module). Returns undefined for None.
export function scourgeBattlePack(scourge) {
    if (scourge === ScourgeType.SoG)
        return MpBattlePack.Ghb2025;
    if (scourge === ScourgeType.SoA)
        return MpBattlePack.Ghb2026;
    return undefined;
}
// specifically Scourge of Ghyran
export function isSoG(item) {
    return item?.scourge === ScourgeType.SoG || item?.sog === true;
}
// Is any type of scourge
export function isScourge(item) {
    return item?.scourge !== ScourgeType.None || item?.sog === true;
}
export function getScourgeType(scourge) {
    if (!scourge)
        return ScourgeType.None;
    if (scourge.sog) {
        return ScourgeType.SoG;
    }
    return scourge?.scourge || ScourgeType.None;
}
export function scourgeToString(scourge) {
    if (!scourge)
        return '';
    if (scourge.sog) {
        return ScourgeType.SoG;
    }
    if (scourge?.scourge === ScourgeType.None) {
        return '';
    }
    return scourge?.scourge || '';
}
// Whether an existing enhancement subgroup `g` should receive an upgrade of the
// given scourge type under table name `name`. Matches by table name AND scourge
// parity: a non-scourge upgrade only joins a non-scourge table (so ordinary
// enhancements group into one table), and a scourge upgrade joins its own
// scourge-suffixed table (e.g. "Foo (Scourge of Ghyran)").
export function matchesScourgeGroup(g, name, scourge) {
    const nameMatches = g.name === name || (scourge !== ScourgeType.None && g.name === `${name} (${scourge})`);
    return nameMatches && getScourgeType(g) === scourge;
}
function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
// Matches a scourge suffix on a unit name, e.g. " (Scourge of Ghyran)" or
// " (Scourge of Aqshy)". Built from the ScourgeType values so new scourges are
// covered automatically.
const scourgeSuffixPattern = new RegExp(`\\s*\\((?:${Object.values(ScourgeType)
    .filter((s) => s !== ScourgeType.None)
    .map(escapeRegExp)
    .join('|')})\\)`);
// Strip a scourge suffix from a unit name, e.g.
// "Liberators (Scourge of Ghyran)" -> "Liberators". Scourge variants are
// rules-only versions of a base datasheet, so this collapses them onto the base.
export function stripScourgeSuffix(name) {
    return name.replace(scourgeSuffixPattern, '');
}
// Get a type from the name
export function nameToScourgeType(name) {
    if (!name.toLowerCase().includes('scourge')) {
        return ScourgeType.None;
    }
    if (name.toLowerCase().includes('ghyran')) {
        return ScourgeType.SoG;
    }
    if (name.toLowerCase().includes('aqshy')) {
        return ScourgeType.SoA;
    }
    return ScourgeType.None;
}
